import { useState } from "react";
import "../Invitation/Invitation.css";
import "./Thanks.css";

const RSVP_THANK_YOU_SUMMARY_KEY = "rsvpThankYouSummary";

const readRsvpSummary = () => {
  try {
    const value = window.sessionStorage.getItem(RSVP_THANK_YOU_SUMMARY_KEY);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.warn("Unable to read RSVP confirmation summary", error);
    return null;
  }
};

const confetti = [
  [-43, -24, 0.03, "#e8b1c3"], [-36, 8, 0.08, "#f2cf78"], [-31, 30, 0, "#9fcac2"],
  [-25, -33, 0.12, "#d8a7d2"], [-20, 20, 0.05, "#efaa89"], [-14, -19, 0.16, "#f6df9e"],
  [-9, 35, 0.09, "#acd7ce"], [-4, -37, 0.02, "#e6a8bc"], [2, 26, 0.14, "#f0c36b"],
  [8, -29, 0.06, "#b6cde6"], [13, 34, 0.11, "#d6abd3"], [19, -16, 0.01, "#f0ad91"],
  [24, 23, 0.15, "#f4d98e"], [29, -35, 0.04, "#9fcfc5"], [34, 12, 0.1, "#eab3c5"],
  [39, 31, 0.07, "#efc873"], [44, -22, 0.13, "#b5d3ce"], [47, 19, 0.02, "#dea9ca"],
  [-48, -6, 0.16, "#f4d98e"], [-40, 38, 0.03, "#9fcfc5"], [-33, -40, 0.09, "#eab3c5"],
  [-17, 41, 0.13, "#efc873"], [-1, -43, 0.06, "#b5d3ce"], [16, 40, 0.01, "#dea9ca"],
  [32, -41, 0.11, "#f0ad91"], [42, 38, 0.05, "#e8b1c3"], [49, -8, 0.14, "#f2cf78"],
];

const confettiRain = [
  [7, 0.2, 6.8, "#e8b1c3"], [18, 2.6, 7.4, "#f2cf78"], [29, 1.1, 6.5, "#9fcac2"],
  [41, 4.2, 7.8, "#d8a7d2"], [53, 0.8, 7.1, "#efaa89"], [65, 3.3, 6.7, "#f6df9e"],
  [77, 1.9, 7.6, "#acd7ce"], [88, 4.8, 6.9, "#e6a8bc"], [96, 2.1, 7.3, "#f0c36b"],
];

const Thanks = () => {
  const [summary] = useState(readRsvpSummary);

  return (
  <main className="thanks-page" dir="rtl">
    <div className="thanks-page__confetti" aria-hidden="true">
      {confetti.map(([x, y, delay, color], index) => (
        <i
          key={`${x}-${y}`}
          className={index % 4 === 0 ? "thanks-confetti thanks-confetti--dot" : "thanks-confetti"}
          style={{ "--burst-x": `${x}vw`, "--burst-y": `${y}vh`, "--delay": `${delay}s`, "--color": color }}
        />
      ))}
    </div>
    <div className="thanks-page__confetti-rain" aria-hidden="true">
      {confettiRain.map(([x, delay, duration, color], index) => (
        <i
          key={`${x}-${delay}`}
          className={index % 3 === 0 ? "thanks-rain-piece thanks-rain-piece--dot" : "thanks-rain-piece"}
          style={{ "--rain-x": `${x}%`, "--rain-delay": `${delay + 1.1}s`, "--rain-duration": `${duration}s`, "--rain-color": color }}
        />
      ))}
    </div>

    <div className="thanks-balloon thanks-balloon--rose" aria-hidden="true"><i /></div>
    <div className="thanks-balloon thanks-balloon--gold" aria-hidden="true"><i /></div>
    <div className="thanks-balloon thanks-balloon--blue" aria-hidden="true"><i /></div>
    <div className="thanks-balloon thanks-balloon--lilac" aria-hidden="true"><i /></div>

    <section className={`thanks-card ${summary ? "thanks-card--with-summary" : ""}`} aria-labelledby="thanks-title">
      <div className="thanks-card__check" aria-hidden="true"><span>✓</span></div>
      <h1 id="thanks-title">
        <span>תודה רבה</span>
        <span className="thanks-card__title-second">- האישור נקלט</span>
      </h1>
      <p>בעלי האירוע מעודכנים אונליין</p>
      <div className="thanks-card__status">
        <span aria-hidden="true" />
        הפרטים נשמרו בהצלחה
      </div>

      {summary && (
        <section className="thanks-summary" aria-labelledby="thanks-summary-title">
          <div className="thanks-summary__heading">
            <h2 id="thanks-summary-title">סיכום האישור</h2>
            <strong>{summary.statusLabel}</strong>
          </div>

          {summary.status === "approved" && (
            <>
              <div className="thanks-summary__people">
                <span>מספר מגיעים</span>
                <strong>{summary.partySize}</strong>
              </div>

              {Array.isArray(summary.dishes) && summary.dishes.length > 0 && (
                <div className="thanks-summary__dishes">
                  {summary.dishes.map((dish) => (
                    <div key={dish.label}>
                      <strong>{dish.count}</strong>
                      <span>{dish.label}</span>
                    </div>
                  ))}
                </div>
              )}

              {(summary.gender || summary.transportation) && (
                <div className="thanks-summary__details">
                  {summary.gender && <span>{summary.gender.male} גברים · {summary.gender.female} נשים</span>}
                  {summary.transportation && (
                    <span>{summary.transportation.needed ? `הסעה: ${summary.transportation.seats} מקומות` : "ללא הסעה"}</span>
                  )}
                </div>
              )}
            </>
          )}
        </section>
      )}
    </section>

    <footer className="invitation-footer thanks-promo">
      <a
        href="https://www.flashback.co.il/he/rsvps/?utm_source=invitations_system&utm_medium=guest_confirmation&utm_campaign=rsvp_footer&utm_content=thanks_page_card"
        target="_blank"
        rel="noopener noreferrer"
        title="אישורי הגעה לאירועים עם פלאשבק הפקות"
        aria-label="למידע על מערכת אישורי הגעה לאירועים של פלאשבק הפקות"
      >
        <img src="/assets/icons/ronenlogo.png" alt="פלאשבק הפקות - אישורי הגעה לאירועים" />
        <span className="invitation-footer__content">
          <small>מתכננים אירוע משלכם?</small>
          <span>מערכת חכמה לניהול אישורי הגעה וסידורי הושבה</span>
        </span>
        <span className="invitation-footer__action">
          <span>אישורי הגעה לאירוע - פלאשבק הפקות</span>
        </span>
        <span className="invitation-footer__party-icon" aria-hidden="true">🎉</span>
      </a>
    </footer>
  </main>
  );
};

export default Thanks;
